import React from "react";
import { Alert, Input, Row, Col, Select, Space, Typography } from "antd";
import { parseNumber } from "../../../services/currencyService.js";
import { NAME_CHANGE_FEE_USD } from "../../../utils/operationRequestNameChange.js";
import styles from "./OperationRequestWorkspace.module.css";

const { Text } = Typography;

/**
 * @param {{
 *   passengers: Array<Record<string, unknown>>,
 *   nameChangePassengerId: string | number | null,
 *   onPassengerChange: (v: string | number | null) => void,
 *   selectedPassenger: Record<string, unknown> | null,
 *   nameChangeNewFirst: string,
 *   nameChangeNewLast: string,
 *   onFirstChange: (s: string) => void,
 *   onLastChange: (s: string) => void,
 *   feePreview: { amountIls?: number | null, exchangeRateUsed?: number | null } | null,
 * }} props
 */
export default function PassengerNameChangeFields({
  passengers,
  nameChangePassengerId,
  onPassengerChange,
  selectedPassenger,
  nameChangeNewFirst,
  nameChangeNewLast,
  onFirstChange,
  onLastChange,
  feePreview,
}) {
  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Alert
        type="info"
        showIcon
        message="שינוי שם נוסע כרוך בעלות טיפול של 40$"
        description="החיוב יחושב לפי שער הדולר העדכני במערכת בזמן יצירת הפנייה."
      />

      <div>
        <span className={styles.formSectionLabel}>בחירת נוסע לשינוי שם</span>
        {passengers.length === 0 ? (
          <Alert
            type="warning"
            showIcon
            message="לא נמצאו נוסעים"
            description="לא ניתן להמשיך בלי רשימת נוסעים. ודא שנטען פירוט מלא או בחר הזמנה אחרת."
          />
        ) : (
          <Select
            size="large"
            allowClear
            placeholder="בחר נוסע"
            style={{ width: "100%" }}
            value={nameChangePassengerId ?? undefined}
            onChange={(v) => onPassengerChange(v ?? null)}
            options={passengers.map((p) => ({
              value: p.id,
              label: `${p.displayName} · ${p.roomLabel}`,
            }))}
          />
        )}
      </div>

      {selectedPassenger ? (
        <>
          <div className={styles.nameChangeBanner}>
            <Text strong>שם נוכחי: </Text>
            <Text>
              {String(selectedPassenger.oldFirstName || "").trim()}{" "}
              {String(selectedPassenger.oldLastName || "").trim()}
            </Text>
            <div style={{ marginTop: 6 }}>
              <Text type="secondary">תצוגה מלאה: {selectedPassenger.displayName}</Text>
            </div>
          </div>

          <div>
            <span className={styles.formSectionLabel}>שם חדש</span>
            <Row gutter={[12, 12]}>
              <Col xs={24} sm={12}>
                <Input
                  size="large"
                  placeholder="שם פרטי חדש *"
                  value={nameChangeNewFirst}
                  onChange={(e) => onFirstChange(e.target.value)}
                />
              </Col>
              <Col xs={24} sm={12}>
                <Input
                  size="large"
                  placeholder="שם משפחה חדש *"
                  value={nameChangeNewLast}
                  onChange={(e) => onLastChange(e.target.value)}
                />
              </Col>
            </Row>
          </div>

          <div className={styles.pricingHighlight}>
            <div>
              <Text type="secondary" style={{ display: "block", fontSize: 13 }}>
                עלות טיפול
              </Text>
              <Text strong style={{ fontSize: 22 }}>
                {parseNumber(NAME_CHANGE_FEE_USD)}$
              </Text>
            </div>
            <div style={{ textAlign: "end" }}>
              {feePreview?.amountIls != null && feePreview?.exchangeRateUsed != null ? (
                <>
                  <Text style={{ fontSize: 16 }}>
                    ≈ {parseNumber(feePreview.amountIls)} ₪
                  </Text>
                  <Text type="secondary" style={{ display: "block", fontSize: 13, marginTop: 4 }}>
                    לפי שער עדכני {feePreview.exchangeRateUsed}
                  </Text>
                </>
              ) : (
                <Text type="secondary">חסר שער דולר/שקל במערכת</Text>
              )}
            </div>
          </div>
        </>
      ) : null}
    </Space>
  );
}
